import styles from "./card.module.css";
import ChampionshipCard from "./championship-card";
import StarterCard from "./starter-card";
const TeamCard = ({ team }) => {
  return (
    <div className={styles.wrapper}>
      {!team.is_in_championship ? (
        <StarterCard team={team}></StarterCard>
      ) : (
        <ChampionshipCard team={team} />
      )}
    </div>
  );
};

export default TeamCard;
